import Vue from 'vue';
import VueRouter, {RouteConfig} from 'vue-router';
import EditList from '@/views/EditList.vue';
import DomainList from "@/views/DomainList.vue";
import EditModify from "@/views/EditModify.vue";
import StationList from "@/views/StationList.vue";
import StationAdd from "@/views/StationAdd.vue";
import Login from "@/views/Login.vue";
import AdCreate from "@/views/AdCreate.vue";
import AccountList from "@/views/AccountList.vue";
import ReportOverview from "@/views/ReportOverview.vue";
import ReportOrder from "@/views/ReportOrder.vue";
import ReportOnline from "@/views/ReportOnline.vue";
import ItemCopy from "@/views/ItemCopy.vue";
import Product from "@/views/Product.vue";

Vue.use(VueRouter);

const routes: RouteConfig[] = [
  {
    path: '/',
    redirect: '/edit/list',
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
  },
  {
    path: '/prod',
    redirect: '/prod/list',
  },
  {
    path: '/prod/list',
    name: 'ProductList',
    component: Product,
  },
  {
    path: '/edit/list',
    name: 'EditList',
    component: EditList,
  },
  {
    path: '/edit/add',
    name: 'EditAdd',
    component: EditModify,
  },
  {
    path: '/edit/modify/:id',
    name: 'EditModify',
    component: EditModify,
  },
  {
    path: '/edit/copy/:id/:country',
    name: 'EditCopy',
    component: EditModify,
  },
  {
    path: '/item/copy',
    name: 'ItemCopy',
    component: ItemCopy,
  },
  {
    path: '/station/list',
    name: 'StationList',
    component: StationList,
  },
  {
    path: '/station/add',
    name: 'StationAdd',
    component: StationAdd,
  },
  {
    path: '/ad/create',
    name: 'AdCreate',
    component: AdCreate,
  },
  {
    path: '/ad/create/:itemId',
    name: 'AdCreate',
    component: AdCreate,
  },
  {
    path: '/account/list',
    name: 'AccountList',
    component: AccountList,
  },
  {
    path: '/domain/list',
    name: 'DomainList',
    component: DomainList,
  },
  {
    path: '/report/overview',
    name: 'ReportOverview',
    component: ReportOverview,
  },
  {
    path: '/report/order',
    name: 'ReportOrder',
    component: ReportOrder,
  },
  {
    path: '/report/online',
    name: 'ReportOnline',
    component: ReportOnline,
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
